jQuery(document).ready(function($){

    highlightHighestRating();

    $(".platform-select").change(function(){
        $(this).parent().parent().swapWith($("[data-comparison-column-id='" + $(this).val() + "']"))
        updateSelects();
        highlightHighestRating();
    });

    $.fn.swapWith = function(to) {
        var copyTo = $(to).clone(true);
        var copyFrom = $(this).clone(true);
        $(to).replaceWith(copyFrom);
        $(this).replaceWith(copyTo)

    };

    function updateSelects() {
        var inactiveOptions = []
        $(".platform-select:hidden").each(function(){
            inactiveOptions.push({id: $(this).val(), text: $("option:selected", this).text()});

        });

        $(".platform-select:visible").each(function(){
            var currentSelect = $(this)
            $("option:not(:selected)", currentSelect).each(function(){
                $(this).remove()
            })

            inactiveOptions.forEach(function(val) {
                currentSelect.append("<option value='" + val.id + "'>" + val.text + "</option>")
            })
        });
    }

    function highlightHighestRating() {
        var ratings = [];
        $(".comparison-table__data .rating-circle:visible").each(function (){
            ratings.push(parseFloat($(this).find(".rating-value").val()))
        })

        var highestRating = Math.max.apply(Math,ratings);

        $(".comparison-table__data .rating-circle:visible").each(function (){
            var percent = $(this).find(".rating-percentage").val();
            var line_bg_color = $(this).find(".rating-line-bg-colour").val();
            if (parseFloat($(this).find(".rating-value").val()) == highestRating) {
                $(this).css("background", "conic-gradient(#FFAE5C "+ percent +"%, "+ line_bg_color +" 0 100%)")
            } else {
                $(this).css("background", "conic-gradient(#000 "+ percent +"%, "+ line_bg_color +" 0 100%)")
            }
        })

    }
});
